import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import { GlobalService } from './compartilhado/servicos/global.service';
import { AutenticacaoService } from './compartilhado/servicos/autenticacao.service';
import { Subscription } from 'rxjs';
import { RequestsService } from './compartilhado/servicos/requests.service';
import { HttpClient } from '@angular/common/http';
import { InterceptorService } from './interceptor-service';
import { LocalStorageService } from 'angular-2-local-storage';
import { ScrollEvent } from 'ngx-scroll-event';
import { SessionService } from './compartilhado/servicos/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, AfterContentChecked, AfterViewInit {
  @ViewChild('main', { static: true }) elRefMain: ElementRef;
  subsAutenticacaoService: Subscription;
  subsOverflow: Subscription;
  subsTema: Subscription;
  subsAcessoEncerrado: Subscription;
  heightOffset: number;
  login = false;
  isMobile: boolean;
  telaExterna = false;
  tema = this.globalService.tema;
  subsLogin: Subscription;
  subsrouter: Subscription;
  acessoEncerrado = false;
  private activatedRoute: any;

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private autenticacaoService: AutenticacaoService,
    private router: Router,
    private route: ActivatedRoute,
    private requestsService: RequestsService,
    private globalService: GlobalService,
    private http: HttpClient,
    private sessionService: SessionService,
    private renderer: Renderer2,
    private interceptorService: InterceptorService,
    private internalStorage: LocalStorageService) {
    const url = location.href;
    // @ts-ignore
    if (url.search('/pagamento') > 1) {
      this.telaExterna = true;
    }

    this.subsLogin = this.autenticacaoService.loginChanged.subscribe(resp => {
      this.login = resp;

      if (!resp) {
        this.renderer.setStyle(this.elRefMain.nativeElement, 'overflow-y', 'auto');
        this.renderer.setStyle(this.elRefMain.nativeElement, 'padding-bottom', '0');
      }
    });

    this.subsrouter = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event && event.url === '/login' || !this.login) {
          return;
        }
        this.autenticacaoService.atualizarSessao();
        this.internalStorage.set('SessionTimeOut', +(this.internalStorage.get('SessionTimeOut')) + this.interceptorService.timeout);
      }
    });
  }

  /* Inicializa o formulário, definindo campos obrigatórios e valores iniciais
   Cria os Subscribes que receberão as respostas de requisições necessárias
   Caso a tela tenha Form, verifica se no serviço já existe uma lista de dados do Grid
   armazenada e a carrega */
  ngOnInit() {
    this.autenticacaoService.prepareEndPoint();

    this.subsOverflow = this.globalService.overflowChanged.subscribe((overflow) => {
      if (overflow) {
        this.renderer.setStyle(this.elRefMain.nativeElement, 'overflow-y', 'auto');
        this.renderer.setStyle(this.elRefMain.nativeElement, 'padding-bottom', '0');
      } else {
        this.renderer.setStyle(this.elRefMain.nativeElement, 'overflow-y', 'hidden');
        this.renderer.setStyle(this.elRefMain.nativeElement, 'padding-bottom', '15px');
      }
    });
  }

  ngAfterViewInit() {
  }

  ngAfterContentChecked() {
    this.onResize();
  }

  @HostListener('window:resize')
  onResize() {
    if (this.globalService.isMobileExtra()) {
      this.isMobile = true;
      this.heightOffset = 0;
    } else {
      this.isMobile = false;
      this.heightOffset = 30;
    }
    if (this.globalService.nativeDocument.getElementById('grid-top')) {
      this.globalService.gridHeight = this.globalService.nativeWindow.innerHeight - this.globalService.nativeDocument.getElementById('grid-top').clientHeight - 33 - 40 - this.heightOffset;
    }
  }

  onScroll(event: ScrollEvent) {
    // Reseta o tempo da sessão expirar sempre que houver scroll na página
    this.sessionService.resetTimer();

    if (this.isMobile) {
      window.scrollTo(0, 1);
      if (event.isReachingBottom) {
        this.globalService.hideNavbar(true);
        this.renderer.setStyle(this.elRefMain.nativeElement, 'margin-top', '0');
        this.renderer.setStyle(this.elRefMain.nativeElement, 'max-height', 'calc(100vh - 60px)');
      }
      if (event.isReachingTop) {
        this.globalService.hideNavbar(false);
        this.renderer.setStyle(this.elRefMain.nativeElement, 'margin-top', '40px');
        this.renderer.setStyle(this.elRefMain.nativeElement, 'max-height', 'calc(100vh - 100px)');
      }
    }
  }
}
